import React from 'react';
import { Typography, Button, Card } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './ContactStyle.scss';
import '../ShoppingCart/ShoppingCartStyle.scss';

function ContactSuccess() {
  const handleBackClick = () => {
    window.location.href = '/';
  };

  return (
    <div className="shopingCart-wrap">
      <div className="purchase-sec">
        <Typography className="main-heading">Contact Submitted</Typography>
        <Card className="purchase-wrap">
          <div className="success-icon-div">
            <div className="svg-icon" style={{ marginBottom: '32px' }}>
              <CheckCircleIcon />
            </div>
            <Typography label="h1" className="heading">
              Thank You!
            </Typography>
          </div>

          <div className="message-wrap">
            <Typography style={{ margin: '20px' }}>
              Your contact information has been submitted successfully. Our admin team will reach out to you within 48 hours.
            </Typography>
          </div>

          <div className="btn-wrap" >
            <Button style={{ marginTop: '50px' }}
              className="btn-cource" 
              onClick={()=> handleBackClick() }
            >
              Back to Home
            </Button>
          </div>
        </Card>
        {/* <div className="help-wrap">
          <div className="help-sec">
            <Typography label="p">
              <span>Need Help?</span>
              <br />
              If you have any questions, call us +1785 98403 4 or contact
              customer@cdlscholl.com
            </Typography>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default ContactSuccess;